window.addEventListener("change", function(e) {
  if (e.target.matches(".product-variant__input")) {
  	console.log(e.target.value.replace(" ", "-").toLowerCase())
    document.querySelector("body").setAttribute("data-current-variant", e.target.value.replace(" ", "-").toLowerCase());
  }
});

window.addEventListener("click", function(e) {
  if (e.target.matches(".thumbnail-link img") || e.target.matches(".play-icon") || e.target.matches(".thumbnail-link span")) {
  	console.log(e.target);

    const galleryItems = document.querySelectorAll(".product-gallery__items .product-gallery__item")
    const galleryItemTarget = parseInt(e.target.getAttribute("data-index")) - 1;
    
    console.log(galleryItems[galleryItemTarget].offsetLeft);
    
  	var elmnt = document.querySelector(".product-gallery__items");
    
	elmnt.scrollLeft = galleryItems[galleryItemTarget].offsetLeft;
  }
});
